module.exports = "05d8eaf3eaab33f08374e3cf32c1b1cf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/platform-edge-R.png
// module id = 40
// module chunks = 0